import { memo } from 'react';
import { Box } from '../../Layout/Box';
import { StyledRootScrollbar, StyledScrollbar } from './styles';
import type { ScrollbarProps } from './types';

/**
 * Scrollbar component that uses custom-styled SimpleBar on desktop
 * and a simple overflow Box on mobile for better touch behavior.
 *
 * @example
 * <Scrollbar sx={{ maxHeight: 300 }}>
 *   <div>Long content...</div>
 * </Scrollbar>
 */
function Scrollbar({ children, sx, ...other }: ScrollbarProps) {
  const normalizedSx = Array.isArray(sx) ? sx : typeof sx === 'function' ? [sx] : [sx || {}];

  const hasNavigator = typeof navigator !== 'undefined';
  const userAgent = hasNavigator ? navigator.userAgent : '';
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

  if (!hasNavigator || isMobile) {
    return (
      <Box sx={[{ overflowX: 'auto' }, ...normalizedSx]} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar sx={normalizedSx} {...other}>
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  );
}

const ScrollbarMemo = memo(Scrollbar);
ScrollbarMemo.displayName = 'Scrollbar';

export { ScrollbarMemo as Scrollbar };
